/**
 * f16.1: "Business Units in cycle <code>" -- one row per unit in f12.1's
 * result, each in its own reporting currency. There is no Input column
 * (Q-f16.1-2): no spec gives a unit an input-completion state.
 */

import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

import type { DashboardScoped } from '@/api/client';
import { deltaClass, formatDelta, formatMoney } from '@/routes/cycles/review/reviewFormat';

import { forecastPath } from './dashboardView';

export function BusinessUnitsTable({ body, canViewUnits }: { body: DashboardScoped; canViewUnits: boolean }) {
  const cycle = body.cycle;
  const units = body.business_units;
  if (!cycle || !units || units.length === 0) return null;

  return (
    <div className="card mt-6">
      <div className="card-head">
        <h3>{`Business Units in cycle ${cycle.code}`}</h3>
        {canViewUnits && (
          <Link className="btn btn-ghost btn-sm" to="/business-units">
            View all <ArrowRight aria-hidden="true" />
          </Link>
        )}
      </div>
      <div className="card-body dash-card-body">
        <div className="table-scroll">
          <table className="data">
            <thead>
              <tr>
                <th>Business Unit</th>
                <th>Group</th>
                <th className="num">Clients</th>
                <th className="num">{`Budget ${cycle.period_year}`}</th>
                <th className="num">{cycle.label}</th>
                <th className="num">Delta to last COM</th>
              </tr>
            </thead>
            <tbody>
              {units.map((unit) => (
                <tr key={unit.id}>
                  <td>
                    <Link className="cell-link" to={forecastPath(cycle.id, unit.id)}>{unit.name}</Link>
                    <span className="sub">{unit.partial ? `${unit.currency_code} · Your clients` : unit.currency_code}</span>
                  </td>
                  <td>{unit.group_name}</td>
                  <td className="num">{unit.client_count}</td>
                  <td className="num" title={body.capabilities.view_budget ? undefined : 'Finance only'}>
                    {formatMoney(unit.budget)}
                  </td>
                  <td className="num" title={`${unit.current_com.amount} ${unit.current_com.currency_code}`}>
                    {formatMoney(unit.current_com)}
                  </td>
                  <td className="num">
                    <span className={deltaClass(unit.delta_to_last_com)}>{formatDelta(unit.delta_to_last_com)}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
